import React from "react";
import RideForm from "../components/RideForm";
import "../css/RideForm.css";

export default function PostRide() {
  // This function runs after the ride is successfully posted to MongoDB
  const handleRidePosted = (ride) => {
    console.log("✅ Ride posted to MongoDB:", ride);

    // Optional: redirect to profile or show confirmation
    // Example: navigate("/profile") or show toast/modal
  };

  return (
    <div className="post-ride-page">
      <div className="post-ride-container">
        <RideForm onSubmit={handleRidePosted} />
      </div>
    </div>
  );
}